/**
 * Domínio: UI de Conexões (canais).
 *
 * Slots da página de Conexões. Acesse via `connections.slots.STATUS`.
 */

export const connections = {
  events: {},
  /** Slots de render. */
  slots: {
    /**
     * Célula de Status do card de conexão. Um plugin pode envolver o status
     * (PluginWrap) para mostrar progresso de inicialização/sync no lugar do
     * indicador padrão (ex: "Carregando 80%", "Sincronizando…").
     */
    STATUS: "connection-status",
    /**
     * Célula de AÇÕES do card de conexão (botões Conectar/QR/Reconectar/
     * Desconectar). Um plugin pode envolver (PluginWrap) para esconder os
     * botões nativos (slot.hide) e colocar os seus por cima — ex: um canal que
     * não usa QR (importa a sessão) esconde "QR Code" e mostra "Importar sessão".
     */
    ACTIONS: "connection-actions",
    /**
     * Área de PREVIEW dentro da aba custom do plugin no formulário de conexão
     * (WhatsAppModal). Um plugin pode montar (slot.mountJsx) uma prévia visual
     * ao vivo do que está configurando — o `context.channelData` chega
     * atualizado a cada mudança de campo (onContextChange), sem precisar
     * salvar a conexão. Ex: widget de chat mostra o balão com a cor/mensagem
     * digitadas em tempo real.
     */
    FORM_PREVIEW: "connection-form-preview",
  },
  hooks: {},
  /**
   * CONTRATO DE DADOS dos slots — o que o `context` entrega a cada slot. É a
   * fonte única de verdade: o call-site preenche estes campos e o plugin lê
   * sabendo o que esperar (não precisa adivinhar). Mantenha alinhado com o
   * `context={...}` da página de Conexões.
   */
  slotContext: {
    "connection-status": {
      whatsappId: "number",
      connectionId: "number",
      channel: "string",          // ex: "whatsapp", "whatsapp_wwebjs"
      status: "string",           // CONNECTED | DISCONNECTED | OPENING | qrcode
      name: "string",
      number: "string",
      isDefault: "boolean",
      channelData: "object?",     // campos custom do canal (JSONB)
      updatedAt: "string",
      connection: "object",       // o objeto Whatsapp COMPLETO (fallback)
    },
    // Mesmo contrato do status — a célula de ações recebe os mesmos dados.
    "connection-actions": {
      whatsappId: "number",
      connectionId: "number",
      channel: "string",
      status: "string",
      name: "string",
      number: "string",
      isDefault: "boolean",
      channelData: "object?",
      updatedAt: "string",
      connection: "object",
    },
    // Formulário de conexão (WhatsAppModal, aba custom do plugin) — channelData
    // reflete o ESTADO ATUAL DIGITADO (antes de salvar), não o persistido.
    "connection-form-preview": {
      whatsappId: "number?",       // ausente ao criar uma conexão nova (ainda sem id)
      channel: "string",
      channelData: "object",       // valores atuais dos campos custom do plugin
    },
  },
} as const;
